import Vue from "vue";
import Vuex from "vuex";

import UserInfo from "./modules/userInfo";
import LineConnect from "./modules/lineConnect";
import LineToken from "./modules/lineToken";
import Contact from "./modules/contact";
import Alert from "./modules/alert";
import Transaction from "./modules/transaction";
import Account from "./modules/account";
import Payment from "./modules/payment";
import Loading from "./modules/loading";
import Product from "./modules/product";
import Setting from "./modules/setting";
import Classification from "./modules/classification";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    UserInfo,
    LineConnect,
    LineToken,
    Contact,
    Alert,
    Transaction,
    Account,
    Payment,
    Loading,
    Product,
    Setting,
    Classification,
  },
  strict: true,
});

export default store;
